export const PATH = {
  HOME: '/',
  LOGIN_BY_TOKEN: '/loginByToken',

  TAX_CDS_INTRODUCE: '/tax-cds/introduce',
  TAX_CDS_SMART_ASSISTANT: '/tax-cds/smart-assistant',
  TAX_CDS_SMART_ASSISTANT_INFO: '/tax-cds/smart-assistant/info',
  
  AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP: '/traffic-fine-lookup',
  AUTO_TRAFFIC_FINE_NOTIFICATION_CHECK_RESULT: '/traffic-fine-check-result',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO: '/traffic-fine-package-info',
  AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES: '/auto-traffic-fine-notification/services',
  AUTO_TRAFFIC_FINE_NOTIFICATION_VEHICLES: '/auto-traffic-fine-notification/vehicles',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT: '/auto-traffic-fine-notification/payment',
  AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE: '/auto-traffic-fine-notification/introduce',
  AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS: '/auto-traffic-fine-notification/success/:id',
  AUTO_TRAFFIC_FINE_NOTIFICATION_AUTHENTICATION: '/auto-traffic-fine-notification/authentication',
  AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS: '/auto-traffic-fine-notification/payment-success',
}
